import { render } from "./CSS3DRoom.vue?vue&type=template&id=61ecf7e0&scoped=true"
import script from "./CSS3DRoom.vue?vue&type=script&lang=js"
export * from "./CSS3DRoom.vue?vue&type=script&lang=js"

import "./CSS3DRoom.vue?vue&type=style&index=0&id=61ecf7e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ecf7e0"]])

export default __exports__